import React from "react";

export const HeaderImage = ({ value, invoiceLogoStyle }) => { 
  if (!value) return null;

  if (invoiceLogoStyle?.display === 'none') return null

  let logoContainerClassName = `justify-content-center`
  let logoStyle = { maxHeight: 200, maxWidth: '100%', width: '1000px' }

  if (invoiceLogoStyle?.height) {
    logoStyle.height = invoiceLogoStyle?.height
  }

  return (
    <div className={`top row mb-2`}>
      {value && (
        <div className={`col-12 d-flex ${logoContainerClassName}`}>
          <img style={logoStyle} src={value} alt="logo" />
        </div>
      )}
    </div>
  );
};

export default HeaderImage;
